export default __webpack_public_path__ + "static/media/29t.ecf45a7e.jpg";